import PropTypes from 'prop-types';
import React from 'react';
import { Radio } from 'antd';
import { CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import ToggleFilter from './toggle-filter';

const sortDirections = ['DESC', 'ASC'];

const SortUpIcon = styled(CaretUpOutlined)`
  font-size: 0.7em;
  margin: 0 -0.2em 0 0.3em;
`;

const SortDownIcon = styled(CaretDownOutlined)`
  font-size: 0.7em;
  margin: 0 -0.2em 0 0.3em;
`;

const ToggleSort = ({ items, value, label, onChange, dark, activeColor }) => {
  const handleSortChange = (e) => {
    const newSortOrder =
      e.target.value === value.order
        ? { ...value, direction: sortDirections?.find(d => d !== value.direction) }
        : { order: e.target.value, direction: sortDirections[0] };
    onChange(newSortOrder);
  };

  const renderItems = () => {
    const handleClick = order => () => handleSortChange({ target: { value: order } });

    if (!items) {
      return null;
    }

    return items?.map(item =>
      <Radio.Button key={item.value} value={item.value} onClick={handleClick(item.value)}>
        {item.text}
        {item.value === value.order &&
          value.direction === 'ASC' ? <SortUpIcon /> : <SortDownIcon />}
      </Radio.Button>,
    );
  };

  return <ToggleFilter
    activeColor={activeColor}
    dark={dark}
    label={label}
    customRender={renderItems}
    value={value.order}
  />;
};

ToggleSort.propTypes = {
  items: PropTypes.array.isRequired,
  value: PropTypes.shape({ order: PropTypes.string, direction: PropTypes.oneOf(sortDirections) }),
  label: PropTypes.string,
  onChange: PropTypes.func,
  dark: PropTypes.bool,
  activeColor: PropTypes.string,
};

export default ToggleSort;
